export function formatNumbersWithDecimal(value) {
  const number = Number(value);

  if (isNaN(number)) return "0.00";

  // toLocaleString handles both thousands separator and decimals
  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
